import { Button } from "./Components/button";
import { useEffect, useState } from "react";

import { globalVariables } from "helper/globalVariables";
import { UploadModal } from "./UploadModal";
export const Upload = (props) => {
  const [showModal, setShowModal] = useState(props?.modalOpen || false);
  useEffect(() => {
    if (props?.modalOpen) {
      setShowModal(props?.modalOpen);
    } else {
      setShowModal(props?.modalOpen);
    }
  }, [props?.modalOpen]);

  const openModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="h-[70vh] flex items-center justify-center">
        <div className=" p-6 rounded-lg text-center">
          <h1 className="text-gray-900 text-center font-inter font-semibold text-xl leading-7">
            {globalVariables.uploadTrialResults}
          </h1>
          <p className="text-gray-700 text-center font-inter font-medium text-md leading-6 mt-2 mb-4">
            {globalVariables.uploadTrialResultsSubTxt}
          </p>

          <Button
            label="Upload Result"
            disabled={false}
            icon={true}
            onClick={openModal}
          />
        </div>
      </div>
      <UploadModal
        showTable={props?.showTable}
        modalOpen={showModal}
        notCloseModal={props?.notCloseModal}
        loading={props?.loading}
      />
    </>
  );
};
